import React, { useEffect, useState } from 'react';
import styles from './SeasonsTable.module.css';
import PropTypes from 'prop-types';
import { convertDateTime } from 'utils/time';
import useGroupLabels from 'hooks/useGroupLabels';

const SeasonsTable = ({ seasons, handleEdit, handleDelete }) => {
  // A club that groups by year level has no age calculation date, so the column is not shown for it.
  const { phrases } = useGroupLabels();
  const [tableData, setTableData] = useState([]);

  useEffect(() => {
    setTableData(
      seasons.map((season) => {
        const canEdit = season.status === 'Draft' || season.status === 'Active';
        const canDelete = season.status === 'Draft';
        return {
          ...season,
          ageCalculationDate: convertDateTime(season.ageCalculationDate).date,
          startDate: convertDateTime(season.startDate).date,
          endDate: convertDateTime(season.endDate).date,
          manage: (
            <div className={styles.actionsCell}>
              <span
                className={`${styles.editIcon} ${canEdit ? '' : styles.disabled}`}
                onClick={() => {
                  if (canEdit) {
                    handleEdit(season);
                  }
                }}
                title={`${canEdit ? 'Edit season' : 'Historical seasons cannot be edited'}`}
              >
                {canEdit ? '✏️' : '🔒'}
              </span>
              {canDelete ? (
                <span
                  className={styles.deleteIcon}
                  onClick={() => handleDelete(season)}
                  title="Delete draft season"
                >
                  🗑️
                </span>
              ) : (
                ''
              )}
            </div>
          ),
        };
      })
    );
  }, [seasons, handleDelete, handleEdit]);

  return (
    <div className={styles.seasonsTable}>
      <table>
        <thead>
          <tr>
            <th>Name</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>Status</th>
            {phrases.hasAgeCalculationDate && <th>Age Calculation Date</th>}
            <th>Actions</th>
          </tr>
        </thead>
        <tbody id="seasonsTableBody">
          {tableData.map((season, index) => {
            return (
              <tr key={index}>
                <td>{season.name}</td>
                <td>{season.startDate}</td>
                <td>{season.endDate}</td>
                <td>
                  <span
                    className={`${styles.statusBadge} ${
                      season.status === 'Draft'
                        ? styles.statusDraft
                        : season.status === 'Active'
                          ? styles.statusActive
                          : styles.statusHistorical
                    }`}
                  >
                    {season.status}
                  </span>
                </td>
                {phrases.hasAgeCalculationDate && <td>{season.ageCalculationDate}</td>}
                <td>{season.manage}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

SeasonsTable.propTypes = {
  seasons: PropTypes.array,
  handleEdit: PropTypes.func,
  handleDelete: PropTypes.func,
};

export default SeasonsTable;
